import { useRef } from 'react';
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import './MainSection.css';

function MainSection() {
  const { sectionRef, isVisible } = useIntersectionObserver();

  return (
    <section id="home" className="main-section" ref={sectionRef}>
      <div className={`iphone-background ${isVisible ? 'animate' : ''}`}>
        <img src={process.env.PUBLIC_URL + '/44.png'} alt="Background" />
      </div>
      <div className={`iphone-background-right ${isVisible ? 'animate' : ''}`}>
        <img src={process.env.PUBLIC_URL + '/441.png'} alt="Background Right" />
      </div>
      <div className={`bottom-image-container ${isVisible ? 'animate' : ''}`}>
        <img src={process.env.PUBLIC_URL + '/46.png'} alt="Bottom decoration" className="bottom-fade-image" />
      </div>
      <div className="main-content">
        <div className={`main-text ${isVisible ? 'animate' : ''}`}>
          <h1>One App. Every Payment.</h1>
          <p>
            Recharge, pay bills, manage loans, and top-up your wallet — all in one smart app. With RSKPay, payments are faster, smarter, and more secure.
          </p>
          <div className="trust-pill">
            <span>☆Trusted by 1,00,000+ customers</span>
          </div>
          <div className="main-buttons">
            <a href="https://app.rskpay.in" target="_blank" rel="noopener noreferrer">
              <button>Get Started</button>
            </a>
            <a href="https://app.rskpay.in" target="_blank" rel="noopener noreferrer">
              <button>Download App</button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MainSection;
